// Lista de destinatários dos envios em massa (disparo e agendamento).

// Junta sem duplicar telefone; quem chega depois com nome preenche o que
// estava sem — reimportar uma planilha com nomes enriquece a lista.
export function acrescentarDestinatarios(lista, novos) {
  const porTelefone = new Map((lista || []).map((d) => [d.phone, d]))
  ;(novos || []).forEach((novo) => {
    const existente = porTelefone.get(novo.phone)
    porTelefone.set(novo.phone, existente ? { ...existente, ...novo } : novo)
  })
  return Array.from(porTelefone.values())
}

const GRUPO = /^[\d-]+@g\.us$/
const TEM_LETRA = /\p{L}/u

// Um número digitado: grupo (…@g.us) fica como veio; telefone vira só dígitos
// e, sem o código do país (até 11 dígitos e sem "+"), recebe o do seletor.
function normalizar(bruto, dialCode, aceitaGrupos) {
  const texto = String(bruto || '').trim()
  if (GRUPO.test(texto)) return aceitaGrupos ? texto : null
  const digitos = texto.replace(/\D/g, '')
  if (!digitos) return null
  const ddi = String(dialCode || '').replace(/\D/g, '')
  const completo = !texto.startsWith('+') && digitos.length <= 11 ? `${ddi}${digitos}` : digitos
  return completo.length >= 10 && completo.length <= 15 ? completo : null
}

// Texto colado: uma linha por destinatário ("número, nome") ou vários números
// separados por vírgula numa linha só, como a tela antiga aceitava. Se o que
// vem depois da vírgula tem letra, é o nome.
export function parsearNumerosComPais(texto, dialCode, { aceitaGrupos = false } = {}) {
  const validos = []
  const invalidos = []
  String(texto || '')
    .split(/\r?\n/)
    .map((linha) => linha.trim())
    .filter(Boolean)
    .forEach((linha) => {
      const partes = linha.split(/[,;]/).map((p) => p.trim()).filter(Boolean)
      const comNome = partes.length === 2 && TEM_LETRA.test(partes[1]) && !GRUPO.test(partes[1])
      const numeros = comNome ? [partes[0]] : partes
      numeros.forEach((bruto) => {
        const phone = normalizar(bruto, dialCode, aceitaGrupos)
        if (!phone) {
          invalidos.push(bruto)
          return
        }
        validos.push(comNome ? { phone, name: partes[1] } : { phone })
      })
    })
  return { validos, invalidos }
}
